import React from 'react';

export const UserMessage = ({ message }) => {
  return (
    <div className="message user-message">
      <div className="message-content">
        {message}
      </div>
    </div>
  );
};

